import { SVGProps } from 'react';

const LiveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={25} height={24} fill='none' {...props}>
    <rect width={24} height={24} x={0.647} fill='#55CDA9' rx={2} />
    <path fill='#fff' d='M9.16 18V6.64h2.207v9.424h5.792V18h-8Z' />
  </svg>
);
export default LiveIcon;
